import { getContentGroup } from '@/core/constants';
import { TypeLink_internal } from '@/core/generated-types';
import { Entry, EntryCollection } from 'contentful';

const LINK_COMPONENT_IDS = ['link_internal', 'linkBannerPage'];

function cleanEntry<T extends object>(entry: Entry<T>) {
  const componentId = entry?.sys?.contentType?.sys?.id;
  const linkEntry = entry as TypeLink_internal;

  if (
    componentId &&
    linkEntry?.fields?.linkContent &&
    LINK_COMPONENT_IDS.includes(componentId)
  ) {
    const slug = linkEntry.fields.linkContent.fields?.slug || '';
    const contentGroup = getContentGroup(linkEntry.fields.linkContent);

    linkEntry.fields.linkContent = {
      sys: linkEntry.fields.linkContent.sys,
      fields: { slug, contentGroup },
    } as any;
    return;
  }

  if (typeof entry === 'object' && !entry.sys) {
    Object.values(entry).forEach(cleanEntry);
  } else {
    Object.values(entry?.fields || {}).forEach((value) => {
      if (Array.isArray(value)) {
        value.forEach(cleanEntry);
      } else if (typeof value === 'object') {
        cleanEntry(value);
      }
    });
  }
}

export default function sanitizeLinks<T extends object>(
  entries: EntryCollection<T>,
) {
  entries.items.forEach(cleanEntry);

  return entries;
}
